import '../app.es6';
import angular from 'angular';

class SharedState {
  /* @ngInject */
  constructor () {
    this._title = 'Coaching system';
    // TODO: Companyにロゴの情報を入れるようにしておき、
    // それをセットするようにしたい。
    this._logo = 'renaissance-logo.png';
  }
  get title () {
    return this._title;
  }
  set title (_title) {
    this._title = _title;
  }
  get logo () {
    return this._logo;
  }
  set logo (_title) {
    this._logo = this._logo;
  }
  get graphPromise () {
    return this._graphPromise;
  }
  set graphPromise (p) {
    this._graphPromise = p;
  }
}

angular.module('myApp').service('sssSharedState', SharedState);



// WEBPACK FOOTER //
// ./app/services/shared-state.es6